import React, { Component } from 'react'
import {Form, Input, message, Radio} from 'antd';
import ModalDom from '../../components/Modal';
import {CustomCol, CustomRow} from "../../components/Custom";
import {config, post} from "../../axios";
import {API_ADDREPAIRREMARKS} from "../../axios/config";
const { TextArea } = Input;

class choose extends Component {
  constructor(props) {
    super()

    this.state = {
      loading: false,
        repairReportId: 0,
      data: [],
      title: '客户签约',
      visible: false,
    }

  }

  componentDidMount() {
    this.props.onRef(this)
  }





  handleOk = () => { // 确定
    this.props.form.validateFieldsAndScroll((error, values) => {
      if (!error) {
          // values.repairReportId = this.state.repairReportId

          const {  remark } = values
          const data = {
              repairReportId: this.state.repairReportId,
              notes: remark,
              state: this.state.newState
              }
          post({
              url: API_ADDREPAIRREMARKS,
              data
          }).then(res => {
              message.success('操作成功!')
              this.setState({ visible: false, data: [] })
              this.resolve(1)
          }).catch(err => {
              message.error(err.message || '更新失败!')
              this.setState({ loading: true })
          })
        this.setState({ visible: false, data: [] })

      }
    })
  }

  handleCancel = () => { // 关闭
    this.setState({ visible: false })
  }

  handleRadioDeviceLeaseChange = (e) => { // 是否设备租赁
        const newState = e.target.value
        this.setState({
            newState
        })
    }

  onShow = (repairReportId) => { // 外部调用
      try {
          this.setState({
              visible: true,
              title: '维修备注',
              repairReportId: repairReportId
          })
          return new Promise((resolve, reject) => {
              this.resolve = resolve
              this.reject = reject
          })
      }catch (w){

      }
  }

  render() {
    const { getFieldDecorator } = this.props.form
    const { visible, loading,  title } = this.state
    const { handleOk, handleCancel } = this

    return (
      <ModalDom
        width="500px"
        title={title}
        loading={loading}
        visible={visible}
        onOk={handleOk}
        onCancel={handleCancel}
      >
        <div className="custom">
          <Form>
              <CustomRow divider>
                  <CustomCol labelStyle={{ height: '30px' }} colStyle={{ width: '350px'}} label="报修状态">
                      {getFieldDecorator('isDeviceLease', {
                          rules: [{
                              required: true, message: '请选择处理状态',
                          }]
                      })(
                          <Radio.Group onChange={this.handleRadioDeviceLeaseChange}>
                              <Radio value={2}>派单中</Radio>
                              <Radio value={3}>维修中</Radio>
                              <Radio value={4}>已完成</Radio>
                          </Radio.Group>
                      )}
                  </CustomCol>

              </CustomRow>
            <CustomRow divider>
                <CustomCol   labelStyle={{ height: '30px' }} colStyle={{ width: '450px', height: '200px' }}>
                    {getFieldDecorator('remark', {
                        rules: [{
                            required: true, message: '请填写报修备注',
                        }]
                    })(
                        <TextArea style={{ height: '100%', padding: '5px', lineHeight: '10px' }} />
                    )}
                </CustomCol>
            </CustomRow>
          </Form>
        </div>
      </ModalDom>
    )
  }
}

export default Form.create()(choose);


// WEBPACK FOOTER //
// ./src/page/DeviceRepairReport/Choose.jsx